import type { InvoiceListItemDto } from '@sr-sdks/api-sdk-axios';
import {
  type InvoicesQueryParams,
  fetchInvoices,
  paidInvoicesParams,
} from '../api/payments/invoiceApi';
import { csvRequestConfig } from '../utils/csv/csvExport';
import { csvColumn, csvDate } from '../utils/csv/toCsvChunk';
import { serviceBadgeLabel } from './Badges/appBadgeConstants';

/** The table's filters; the export supplies its own page and pageSize. */
export type StatementsCsvParams = Omit<
  InvoicesQueryParams,
  'page' | 'pageSize' | 'status'
>;

const col = csvColumn<InvoiceListItemDto>;

/**
 * The statements table's columns (APP-2510 D15). Service is always listed: the
 * Payments pages that export never use the collection-account mode that hides it.
 */
export const statementsCsvColumns = [
  col('date', 'Date', (row) => csvDate(row.invoiceDate)),
  col('payoutReferenceId', 'Payout reference ID', (row) => row.payoutRefNo),
  col('title', 'Title', (row) => row.beneficiaryTitleName),
  col('client', 'Client', (row) => row.beneficiaryClientName, true),
  col('service', 'Service', (row) => serviceBadgeLabel(row.serviceType)),
  col('amount', 'Amount', (row) => row.amountNet),
  col('currency', 'Currency', (row) => row.currency),
];

export const fetchStatementsCsvPage = (
  params: StatementsCsvParams,
  page: number,
  pageSize: number,
  signal: AbortSignal,
) =>
  fetchInvoices(
    paidInvoicesParams({ ...params, page, pageSize }),
    csvRequestConfig(signal),
  );
